import Img2 from "../images/testimonials/pfp1.jpg";
import Img3 from "../images/testimonials/pfp2.jpg";

function Testimonials() {
  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>Avis de nos clients</h4>
                <h2>Témoignages</h2>
                <p>
                  Découvrez l’impact positif que nous avons apporté à nos clients en parcourant
                  leurs témoignages. Ils ont fait l’expérience de nos services et de nos résultats,
                  et souhaitent partager leurs retours positifs avec vous.
                </p>
            </div>

            <div className="all-testimonials">
              <div className="all-testimonials__box">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                  <p>
                    "Nous avons loué un camion pour notre mariage via ce site et l’expérience a été excellente !
                    La réservation était simple et les tarifs de location très abordables."
                  </p>
                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img2} alt="user_img" />
                    <span>
                      <h4>Nobila Traore</h4>
                      <p>Septembre 2025</p>
                    </span>
                  </div>
                </div>
              </div>

              <div className="all-testimonials__box box-2">
                <span className="quotes-icon">
                  <i className="fa-solid fa-quote-right"></i>
                </span>
                  <p>
                    "La voiture était en excellent état et a rendu notre voyage encore meilleur.
                    Je recommande vivement ce site de location !"
                  </p>

                <div className="all-testimonials__box__name">
                  <div className="all-testimonials__box__name__profile">
                    <img src={Img3} alt="user_img" />
                    <span>
                      <h4>Maimouna Nana</h4>
                      <p>Janvier 2022</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
